import { useAppSelector } from 'hooks';
import React, { FC, useMemo } from 'react';

import styles from './styles.module.sass';

export const PatientStatistic: FC = () => {
  const { studyStatistic, studyFacilityId } = useAppSelector((state) => state.study);

  const statisticItems: StatisticItemProps[] = useMemo(() => {
    if (!studyStatistic) {
      return [];
    }

    const { totalCount, afib, bradycardia, tachycardia, normalSinusRhythm, inconclusive, unreadable } = studyStatistic;

    return [
      {
        title: 'Total',
        value: totalCount,
      },
      {
        title: 'Afib',
        value: afib,
      },
      {
        title: 'Bradycardia',
        value: bradycardia,
      },
      {
        title: 'Tachycardia',
        value: tachycardia,
      },
      {
        title: 'Normal Sinus Rhythm',
        value: normalSinusRhythm,
      },
      {
        title: 'Inconclusive',
        value: inconclusive,
      },
      {
        title: 'Unreadable',
        value: unreadable,
      },
    ];
  }, [studyStatistic]);

  if (!studyStatistic) {
    return <h5>No statistics</h5>;
  }

  return (
    <>
      {!studyFacilityId && <h3>Total statistics: </h3>}
      {statisticItems.length && (
        <p>
          {statisticItems.map((item) => (
            <StatisticItem key={item.title} title={item.title} value={item.value} />
          ))}
        </p>
      )}
    </>
  );
};

type StatisticItemProps = {
  title: string;
  value: number | string | undefined;
};

const StatisticItem: FC<StatisticItemProps> = ({ title, value }) => {
  return (
    <span className={styles.item}>
      <span className={styles.itemTitle}>{title}: </span>
      <span>{value}</span>
    </span>
  );
};
